<template>
    <v-app id="inspire">
        <v-navigation-drawer
            v-if="!loading.data"
            v-model="drawer"
            expand-on-hover
            mini-variant
            app>
            <v-list dense>
                <v-list-group v-for="(navGroup, index) in navGroups.filter(each => each.authorization == true)" :key="index">
                    <template v-slot:activator>
                        <v-list-item-icon>
                            <v-icon color="primary">{{ navGroup.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ navGroup.text }}</v-list-item-title>
                    </template>
                    <v-list-item link
                        v-for="(navItem, navItemIndex) in navGroup.navItems.filter(each => each.authorization == true)"
                        :key="navItemIndex"
                        :to="navItem.to"
                        dense>
                        <v-list-item-icon>
                            <v-icon>{{ navItem.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ navItem.text }}</v-list-item-title>
                    </v-list-item>
                </v-list-group>
            </v-list>
        </v-navigation-drawer>
        <v-app-bar
            app
            dense
            elevation="1"
            color="white">
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
            <v-toolbar-title>{{ $t('financial_accounting') }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <ToolbarMenuRight/>
        </v-app-bar>
        <v-main>
            <v-container :fill-height="checkRouter ? true: false" fluid>
                <router-view v-if="!loading.data"></router-view>
            </v-container>
        </v-main>
        <SnackbarAlert
            ref="snackbarAlert"/>
        <v-snackbar :value="snackbar.display" @input="hideSnackbar" :color="snackbar.color" bottom right>{{snackbar.text}}</v-snackbar>
    </v-app>
</template>

<script>
import SnackbarAlert from '@/components/common/SnackbarAlert';
import ToolbarMenuRight from '@/components/common/ToolbarMenuRight'
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import { mapState } from 'vuex';
import authorize from '../utils/authorize';

// import HomeLayout from './HomeLayout.vue';
    export default {
        components: {
            ToolbarMenuRight,
            SnackbarAlert,
            // HomeLayout
        },
        props: {
            source: String,
        },
        data: () => ({
        drawer: null,
        darkMode: false,
        module: 'accounting',
        loading: {
            data: false
        }
        }),
        computed: {
            ...mapState('authentication', ["authorizations"]),
            ...mapGetters({
                snackbar: "ui/snackbar/snackbar",
            }),
            checkRouter() {
                if(this.$route.path == '/accounting') return true;
                else return false;
            },
            navGroups() {
                return [
                    {
                        text: this.$t('pre_accounting_activities'),
                        icon: "mdi-folder",
                        authorization:  this.authorizations.reports.chart_of_accounts || this.authorizations.journal_voucher.read,
                        navItems: [
                            {
                                text: this.$t('chart_of_accounts'),
                                icon: "mdi-finance",
                                to: "/accounting/chart-of-accounts",
                                authorization: this.authorizations.reports.chart_of_accounts,
                            },
                            {
                                text: this.$t('accounts'),
                                icon: "mdi-view-list",
                                to: "/accounting/accounts",
                                authorization: this.authorizations.reports.chart_of_accounts,
                            },
                            {
                                text: this.$t('dimensions'),
                                icon: "mdi-graph",
                                to: "/accounting/dimensions",
                                authorization: true,
                            }
                        ]
                    },
                    {
                        text: "General Ledger",
                        icon: "mdi-folder",
                        authorization:  this.authorizations.reports.chart_of_accounts || this.authorizations.journal_voucher.read,
                        navItems: [
                            {
                                text: this.$t('journal_entry'),
                                icon: "mdi-alarm-panel",
                                to: "/accounting/journal-entry",
                                authorization: this.authorizations.journal_voucher.read
                            },
                        ]
                    },
                    {
                        text: this.$t('reporting'),
                        icon: "mdi-folder",
                        authorization: this.authorizations.reports.account_statement || this.authorizations.reports.trial_balance,
                        navItems: [
                            {
                                text: this.$t('account_statements'),
                                icon: 'mdi-file-chart',
                                to: '/accounting/account-statements',
                                authorization: this.authorizations.reports.account_statement
                            },
                            {
                                text: this.$t('trial_balance'),
                                icon: 'mdi-cash-check',
                                to: '/accounting/trial-balance',
                                authorization: this.authorizations.reports.trial_balance
                            },
                            {
                                text: this.$t('dimension_reports'),
                                icon: 'mdi-filter',
                                to: '/accounting/dimensions-report',
                                authorization: this.authorizations.reports.trial_balance
                            },
                        ]
                    },
                    {
                        text: this.$t('period_closing'),
                        icon: "mdi-folder",
                        authorization: authorize("period:closing"),
                        navItems: [
                            {
                                text: this.$t('exchange_gain_loss'),
                                icon: "mdi-currency-usd",
                                to: "/accounting/exchange-difference",
                                authorization: authorize("period:closing"),
                            },
                            {
                                text: this.$t('retained_earning'),
                                icon: "mdi-transmission-tower-import",
                                to: "/accounting/retained-earning",
                                authorization: authorize("period:closing")
                            },
                        ]
                    },
                    {
                        text: this.$t('settings'),
                        icon: "mdi-folder",
                        authorization: true,
                        navItems: [
                            {
                                text: this.$t('currency_index'),
                                icon: "mdi-cash-multiple",
                                to: "/accounting/currencies",
                                authorization: true
                            },
                            {
                                text: this.$t('exchange_rates'),
                                icon: "mdi-cash-fast",
                                to: "/accounting/exchange-rates",
                                authorization: true
                            },
                            {
                                text: this.$t('bank_account'),
                                icon: "mdi-wallet",
                                to: "/accounting/bank-accounts",
                                authorization: true,
                            },
                            {
                                text: "Export Transactions",
                                icon: "mdi-file-excel-outline",
                                to: "/accounting/transactions-export",
                                authorization: authorize("export:trialBalance")
                            }
                        ]
                    }
                ]
            }

        },
        methods: {
            moment,
            ...mapActions('authentication', ['fetchAuthorizations']),
            ...mapActions({
                hideSnackbar: "ui/snackbar/hide"
            }),
            async createdDataFetch(){
                try {
                    this.loading.data = true;
                    await this.fetchAuthorizations(this.module);
                    this.loading.data = false;
                } catch(error) {
                    this.loading.data = false;
                    let message = error.response ? error.response.data.message : error;
                    this.$refs.retryDialog.open({target:"createdDataFetch",message});
                }
            }
        },
        created(){
            this.createdDataFetch();
        }
    }
</script>